module.exports = __webpack_public_path__ + "assets/img/jtwo.9da26286.png";